import { param } from "jquery";
import http from "./http";

var baseUrl = "/supplier-web" ;//
var baseUrluser="/appuser-web";
var baseUrlContract="contract-web"
//甲方供应商列表列表
const getSupplierAList = (param, loading = false) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/list", param, false, loading)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询有效供应商列表
const getValidSupplierAList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/valid/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询一条甲方供应商
const getSupplierADetailService = (param, loading = false) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/detail", param, false, loading)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 保存甲方供应商信息
const saveSupplierAInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/supplier/aType", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 更新甲方供应商信息
const updateSupplierAInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/aType", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 更新我的企业信息供应商信息
const updateSupplierOwnInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/own", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};



//更新供应商状态
const updateSupplierStatus = param => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/status", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 供应商上传图片接口
const uploadSupplierFilesService = param => {
  return new Promise((resolve, reject) => {
    http
      .post(
        baseUrl + "/oss/upload/supplier/pic",
        param,
        false,
        true,
        true
      )
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//乙方供应商相关接口
//乙方供应商列表列表
const getSupplierBList = (param, loading = false) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplierB/list", param, false, loading)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询有效供应商列表
const getValidSupplierBList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplierB/valid/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询供应商操作日志列表
const getEditSupplierLogList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/log/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询供应商操作日志列表
const getStatusSupplierLogList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/statusLog/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询一条乙方供应商
const getSupplierBDetailService = (param, loading = false) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplierB/detail", param, false, loading)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 保存乙方供应商信息
const saveSupplierBInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/supplier/bType", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 更新乙方供应商信息
const updateSupplierBInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/bType", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//更新供应商状态
const updateSupplierBStatus = param => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplierB", param, true)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//供应商类别相关接口
//查询供应商一级类别列表
const getSupplierTypeList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/type/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询子类别列表
const getSuppliersubTypeList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/type/sub/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//新建供应商类别
const saveSupplierTypeInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/supplier/type", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 更新供应商类别
const updateSupplierTypeInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/type", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 删除供应商类别
const delSupplierTypeInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + "/supplier/type", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//供应商账号管理相关接口
/* 获取供应商getSysUserAccountService用户列表 */
const getSupllierUserAccountService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrluser + "/user", reqParam, true)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 新增供应商用户 */
const addSupplierUserService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrluser + "/user/supplier", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 修改供应商用户信息 */
const modifySupplierUserService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrluser + "/user/supplier", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 更新供应商状态信息 */
const modifySupplierUserStatusService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrluser + "/user/status", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 冻结供应商用户 */
const deleteSupplierUserService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrluser + "/user", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//供应商评价接口
//查询供应商评价列表
const getSupplierEvaluateList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/score/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询供应商评分详情
const getSupplierEvaluateDetailService = (param, loading = false) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/score/detail", param, false, loading)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 供应商生产部门评分
const savePSupplierEvaluateInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/score/product", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 供应商主管部门评分
const saveMSupplierEvaluateInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/score/duty", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//评分账号管理接口
//查询查询权限列表
const getEvaluateUserList = (param) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/score/permission/list", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询部门权限详情 
const getEvaluateUserDetailService = (param, loading = false) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/score/permission/detail", param, false, loading)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询用户权限
const getEvaluateUserService = (param, loading = false) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/supplier/score/permission", param, false, loading)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 新增评分权限账户
const saveEvaluateUserInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/score/permission", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 删除评分权限账户
const delEvaluateUserInfo = reqParam => {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + "/supplier/score/permission", reqParam, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//导出供应商评价列表
const exportevaluateListExcel = (param) => {
  return new Promise((resolve, reject) => {
    http.get(baseUrl + "/supplier/score/list/export",param)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//导出集团总台帐
const exportscoreExportExcel = () => {
  return new Promise((resolve, reject) => {
    http.post(baseUrlContract + "/project/scoreExport/export/all", '',false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//导出项目部总台帐
const exportDeptExcel = param => {
  return new Promise((resolve, reject) => {
    http.post(baseUrlContract + "/project/scoreExport/dept", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//导出项目部项目总台帐
const exportProjectDeptExcel = param => {
  return new Promise((resolve, reject) => {
    http.post(baseUrlContract + "/project/scoreExport/project", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//供应商审批流相关接口
//查询审批列表接口
const getApproveListService = param => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/approve/queryApproveProcess", param, true)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//查询当前审批流接口
const getCurrentApproveListService = param => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/approve/queryCurrentApproveProcess", param, true)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//审批供应商接口
const confirmSupplierApproveServices = param => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/approve/submitApproveProcess", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//保存评价表打印信息
const savePrintEvaluateInfo = param => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/supplier/score/print", param, false)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};




export {
  getSupplierAList, //获取供应商列表
  getValidSupplierAList, //查询有效供应商列表
  getSupplierADetailService, //查询一条甲方供应商
  saveSupplierAInfo, // 保存甲方供应商信息
  updateSupplierAInfo,  //更新甲方供应商信息
  updateSupplierOwnInfo,  //更新我的企业信息供应商信息
  updateSupplierStatus, //更新供应商状态
  uploadSupplierFilesService,  //上传文件接口

  getSupplierBList, //获取供应商列表
  getValidSupplierBList, //查询有效供应商列表
  getSupplierBDetailService, //查询一条乙方供应商
  saveSupplierBInfo, // 保存乙方供应商信息
  updateSupplierBInfo,  //更新乙方供应商信息
  updateSupplierBStatus, //更新供应商状态
  getEditSupplierLogList,
  getStatusSupplierLogList,

  //供应商类别相关接口
  getSupplierTypeList,  //获取供应商一级类别列表接口
  getSuppliersubTypeList,  //查询子类别列表接口
  saveSupplierTypeInfo,   //新建供应商类别
  updateSupplierTypeInfo, //更新供应商类别
  delSupplierTypeInfo,   //删除供应商类别
  //供应商评价相关接口
  getSupplierEvaluateList,//查询供应商评价列表
getSupplierEvaluateDetailService,//查询供应商评分详情
savePSupplierEvaluateInfo, //查询供应商评分详情
saveMSupplierEvaluateInfo, // 供应商主管部门评分

getEvaluateUserList,//查询查询权限列表
getEvaluateUserDetailService,//查询用户权限详情 
getEvaluateUserService ,  //查询用户权限
saveEvaluateUserInfo,// 新增评分权限账户
delEvaluateUserInfo ,// 删除评分权限账户
exportevaluateListExcel,  //导出供应商评价列表
exportscoreExportExcel, //导出集团总台帐
exportDeptExcel, //导出项目部总台帐
exportProjectDeptExcel, //导出项目部项目总台帐
savePrintEvaluateInfo,

//审批流相关接口
getApproveListService,
confirmSupplierApproveServices,
getCurrentApproveListService,  //查询当前审批流

  //供应商用户相关接口
  getSupllierUserAccountService,   //获取供应商用户列表
  addSupplierUserService,     //新增供应商用户
  modifySupplierUserService,   //修改供应商用户信息
  deleteSupplierUserService,   //冻结供应商用户
  modifySupplierUserStatusService  //更新供应商状态信息


};
